export default __webpack_public_path__ + "static/media/ApercuRegular.83b693d3.otf";